export default {
  TYPES: {
    MENU_PANEL: 'MENU_PANEL',
    PROPERTY_PANEL: 'PROPERTY_PANEL',
    DATA_PANEL: 'DATA_PANEL',
    EDITOR_PANEL: 'EDITOR_PANEL',
    LAYOUT_CONTROL_PANEL: 'LAYOUT_CONTROL_PANEL',
    INPUT_DIALOGS: 'INPUT_DIALOGS',
  },
  MENU_PANELS: {
    SAVE_BUTTON: 'SAVE_BUTTON',
    SAVE_BUTTON_DROP_DOWN: 'SAVE_BUTTON_DROP_DOWN'
  },
  PROPERTY_PANELS: {
    COLOR: 'components/Toolbar/PropertiesMenu/shared/ColorPanel/ColorPanel',
    TEXTURE_OR_GRADIENT: 'components/Toolbar/PropertiesMenu/properties/BackgroundProperty/TextureOrGradientPanel/TextureOrGradientPanel',
    FONT_FAMILY: 'components/Toolbar/PropertiesMenu/properties/FontProperty/FontFamilyPanel/FontFamilyPanel',
    FONT_SIZE: 'components/Toolbar/PropertiesMenu/properties/FontProperty/FontSizePanel/FontSizePanel',
    MOBILE_FONT_SIZE: 'components/Toolbar/PropertiesMenu/properties/FontProperty/MobileFontSizePanel/MobileFontSizePanel',
    FONT_MORE_ACTIONS: 'components/Toolbar/PropertiesMenu/properties/FontProperty/FontMoreActionsPanel/FontMoreActionsPanel',
    PADDING: 'components/Toolbar/PropertiesMenu/properties/BorderProperty/PaddingPanel/PaddingPanel',
    BORDER: 'components/Toolbar/PropertiesMenu/properties/BorderProperty/BorderPanel/BorderPanel',
    SHADOW: 'components/Toolbar/PropertiesMenu/properties/BorderProperty/ShadowPanel/ShadowPanel',
    BORDER_WIDTH: 'components/Toolbar/PropertiesMenu/properties/BorderProperty/BorderWidthPanel/BorderWidthPanel',
    BORDER_RADIUS: 'components/Toolbar/PropertiesMenu/properties/BorderProperty/BorderRadiusPanel/BorderRadiusPanel',
  },
  DATA_PANELS: {
    VIDEO: 'components/ElementsDialogs/VideoDialog/VideoDialogWrapper',
    IMAGE: 'components/ElementsDialogs/ImageDialog/ImageDialogWrapper',
    GALLERY: 'components/ElementsDialogs/GalleryDialog/GalleryDialogWrapper',
    ICON: 'components/ElementsDialogs/IconDialog/IconDialogWrapper',
    HTML: 'components/ElementsDialogs/HtmlDialog/HtmlDialogWrapper',
    TABS: 'components/ElementsDialogs/TabsDialog/TabsDialogWrapper',
    HYPERLINK: 'components/ElementsDialogs/HyperlinkDialog/HyperlinkDialogWrapper',
    CROSS_SELL_GALLERY: 'components/ElementsDialogs/CrossSellGalleryDialog/CrossSellGalleryDialogWrapper',
  },
  LAYOUT_CONTROL_PANELS: {
    ARRANGE: 'components/ElementControls/controls/LayoutControl/ArrangeControlPanel/ArrangeControlPanel',
    ALIGN: 'components/ElementControls/controls/LayoutControl/AlignObjectsControlPanel/AlignObjectsControlPanel',
  },
  EDITOR_PANELS: {
    CONNECT_EBAY: 'components/ConnectEbayDialog/ConnectEbayDialog',
    LIMIT_REACHED: 'components/LimitReachedDialog/LimitReachedDialog',
    TEMPLATE_NAME: 'components/TemplateNameDialog/TemplateNameDialog',
    TRIAL_EXPIRED: 'components/TrialExpired/TrialExpired',
    LOGIN: 'components/LoginWidgetDialog/LoginWidgetDialog',
    SAVE_AS_TEMPLATE: 'components/SaveAsTemplateDialog/SaveAsTemplateDialog'
  },
  INPUT_DIALOGS: {
    ITEM_ID: 'components/ItemIdDialog/ItemIdDialog',
  },
  BACKGROUND_IMAGE_TYPE: {
    GRADIENT: 'gradient',
    TEXTURE: 'texture',
  },
  BORDER_PANEL_TYPE: {
    TYPE: 'type',
    SHADOW: 'shadow',
  },
  BORDER_RADIUS_PROP_NAMES: [
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
  ],
  PADDING_PROP_NAMES: [
    'paddingTop',
    'paddingLeft',
    'paddingRight',
    'paddingBottom',
  ],
};
